import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [MatDialogModule, MatIconModule, MatButtonModule],
})
export class ConfirmDialogComponent {
    dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);

    public okText: string;
    public cancelText: string;
    public title: string;
    public message: string;

    constructor() {
        const data = inject(MAT_DIALOG_DATA);

        this.okText = data?.okText ?? 'Potvrdit';
        this.cancelText = data?.cancelText ?? 'Zrušit';
        this.title = data?.title;
        this.message = data?.message;
    }
}
